/**
 * [locations_search] entry — the standalone suburb/postcode box that redirects
 * to the map page (rendered on every page via the theme footer). Must stay
 * free of mapbox-gl / react-map-gl imports so non-map pages never download
 * the map bundle; the map itself lives in main.tsx.
 */
import { createRoot } from "react-dom/client";
import { LocationSearchStandalone } from "./components/LocationSearchStandalone";
import { getLocationsMapConfig, onDomReady, prepareShadow } from "./lib/shadow";
import "./styles/main.css";

function renderSearchIntoShadow(host: Element) {
  const element = host as HTMLElement;
  if (!element.style.position) {
    element.style.position = "relative";
  }
  const shadow = prepareShadow(element, "cssHref");

  const mount = document.createElement("div");
  mount.style.width = "100%";
  shadow.appendChild(mount);

  // Get base path from config, default to "/locations" if not set
  const config = getLocationsMapConfig();
  const basePath =
    config && typeof config.basePath === "string"
      ? config.basePath
      : "/locations";

  createRoot(mount).render(<LocationSearchStandalone basePath={basePath} />);
}

function initializeSearchWidgets() {
  const containers = document.querySelectorAll(".locations-search-container");
  containers.forEach((container) => {
    try {
      renderSearchIntoShadow(container);
    } catch (error) {
      console.error("Failed to initialize locations search:", error);
    }
  });
}

onDomReady(initializeSearchWidgets);
